import React from 'react';
import styles from './progress.module.css';

const ProgressBar = ({value, style}) => {
    return (
        <div className={styles.Progress} style={style}>
            <div className={styles.Bar} style={{width: value+"%"}}>
            </div>
        </div>
    );
}

export default ProgressBar;